<div class="modal-header pn-header">
    <div>
        <h4 class="modal-title mb-0"><i class="fa fa-hashtag me-2 pn-header-icon"></i>Part Number Generator</h4>
        <p class="pn-header-sub mb-0">Build a part number step-by-step to find matching parts</p>
    </div>
</div>

<div class="modal-body pn-body">
    <div class="pn-layout">

        <!-- ── Configuration Form ────────────────────────────────── -->
        <div class="pn-form-panel">

            <!-- Section 1: Trailer Base -->
            <div class="pn-section">
                <div class="pn-section-header">
                    <span class="pn-step-badge">1</span>
                    <span>Trailer Base</span>
                </div>
                <div class="row g-3 pn-section-body">
                    <div class="col-12">
                        <div class="pn-label-row">
                            <label class="pn-label">Model</label>
                            <i class="fa fa-times pn-clear-btn" *ngIf="partSelection.modelTypeId" (click)="clearModelType()"></i>
                        </div>
                        <dx-select-box
                            [(value)]="partSelection.modelTypeId"
                            [items]="modelTypes"
                            valueExpr="id"
                            displayExpr="displayName"
                            [width]="'100%'"
                            (onValueChanged)="onModelTypeChanged($event)"
                        ></dx-select-box>
                    </div>
                    <div class="col-12">
                        <div class="pn-label-row">
                            <label class="pn-label">Size / Length</label>
                            <i class="fa fa-times pn-clear-btn" *ngIf="partSelection.sizeId" (click)="clearSize()"></i>
                        </div>
                        <dx-select-box
                            [(value)]="partSelection.sizeId"
                            [items]="matchingModelSizes"
                            valueExpr="id"
                            displayExpr="displayName"
                            [width]="'100%'"
                            (onValueChanged)="onSizeChanged($event)"
                        ></dx-select-box>
                    </div>
                </div>
            </div>

            <!-- Section 2: Axle & Brakes -->
            @if (showAxleSection) {
            <div class="pn-section">
                    <div class="pn-section-header">
                        <span class="pn-step-badge">2</span>
                        <span>Axle &amp; Brakes</span>
                    </div>
                    <div class="row g-3 pn-section-body">
                        <div class="col-12">
                            <div class="pn-label-row">
                                <label class="pn-label">Axle(s)</label>
                                <i class="fa fa-times pn-clear-btn" *ngIf="partSelection.axleId" (click)="clearAxle()"></i>
                            </div>
                            <dx-select-box
                                [(value)]="partSelection.axleId"
                                [items]="partSelection.size?._axleSizes"
                                valueExpr="entityId"
                                displayExpr="name"
                                [width]="'100%'"
                                (onValueChanged)="onAxleChanged($event)"
                                [disabled]="partSelection.size?.noAxles"
                            ></dx-select-box>
                            <div *ngIf="partSelection.size?.noAxles" class="pn-warning-msg">
                                <i class="fa fa-info-circle"></i> Axle selection disabled for selected model size.
                            </div>
                        </div>
                        <div class="col-12" *ngIf="partSelection.sizeId">
                            <div class="pn-label-row">
                                <label class="pn-label">Axle Suspension</label>
                            </div>
                            <dx-radio-group
                                [(value)]="partSelection.axleSuspension"
                                [items]="['Leaf Spring', 'Torsion Spring']"
                                layout="horizontal"
                                [disabled]="!hasTorsionOption"
                                (onValueChanged)="onAxleSuspensionChanged($event)"
                            ></dx-radio-group>
                        </div>
                        @if (partSelection?.model?.hasBrakes) {
                            <div class="col-12">
                                <div class="pn-label-row">
                                    <label class="pn-label">Brake Axle Count</label>
                                    <i class="fa fa-times pn-clear-btn" *ngIf="partSelection.brakeCount != null" (click)="clearBrakeCount()"></i>
                                </div>
                                <dx-select-box
                                    [(value)]="partSelection.brakeCount"
                                    [items]="brakeCount"
                                    [disabled]="!partSelection.axleId || partSelection.size?.noBrakeOption"
                                    [width]="'100%'"
                                    (onValueChanged)="onBrakeCountChanged($event)"
                                ></dx-select-box>
                            </div>
                            <div class="col-12">
                                <div class="pn-label-row">
                                    <label class="pn-label">Brake Type</label>
                                    <i class="fa fa-times pn-clear-btn" *ngIf="partSelection.brakeTypeId" (click)="clearBrakeType()"></i>
                                </div>
                                <dx-select-box
                                    [(value)]="partSelection.brakeTypeId"
                                    [items]="brakeOptions"
                                    valueExpr="id"
                                    displayExpr="name"
                                    [disabled]="!partSelection.axleId || partSelection.brakeCount === 0 || partSelection.size?.noBrakeOption"
                                    [width]="'100%'"
                                    (onValueChanged)="onBrakeTypeChanged($event)"
                                ></dx-select-box>
                                <div *ngIf="partSelection.size?.noBrakeOption" class="pn-warning-msg">
                                    <i class="fa fa-info-circle"></i> Brake selection disabled for selected model size.
                                </div>
                            </div>
                        }
                        <!-- Axle Brake Summary -->
                        <div class="col-12" *ngIf="partSelection.axleId === 1 || partSelection.axleId === 2 || partSelection.axleId === 3">
                            <label class="pn-label">Axle Brake Configuration</label>
                            <div class="pn-brake-indicators">
                                <div class="pn-brake-indicator" *ngIf="partSelection.axleId === 1 || partSelection.axleId === 2 || partSelection.axleId === 3">
                                    <span class="pn-bi-label">Axle 1</span>
                                    <dx-select-box
                                        [(value)]="partSelection.brake1Id"
                                        [items]="brakes"
                                        valueExpr="id"
                                        displayExpr="name"
                                        [disabled]="true"
                                        [width]="'120px'"
                                        [showDropDownButton]="false"
                                    ></dx-select-box>
                                </div>
                                <div class="pn-brake-indicator" *ngIf="partSelection.axleId === 2 || partSelection.axleId === 3">
                                    <span class="pn-bi-label">Axle 2</span>
                                    <dx-select-box
                                        [(value)]="partSelection.brake2Id"
                                        [items]="brakes"
                                        valueExpr="id"
                                        displayExpr="name"
                                        [disabled]="true"
                                        [width]="'120px'"
                                        [showDropDownButton]="false"
                                    ></dx-select-box>
                                </div>
                                <div class="pn-brake-indicator" *ngIf="partSelection.axleId === 3">
                                    <span class="pn-bi-label">Axle 3</span>
                                    <dx-select-box
                                        [(value)]="partSelection.brake3Id"
                                        [items]="brakes"
                                        valueExpr="id"
                                        displayExpr="name"
                                        [disabled]="true"
                                        [width]="'120px'"
                                        [showDropDownButton]="false"
                                    ></dx-select-box>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

            <!-- Section 3: Running Gear (no suspension) -->
            @if (!partSelection?.model?.hasSuspension || partSelection.size?.noSuspension) {
                <div class="pn-section">
                    <div class="pn-section-header">
                        <span class="pn-step-badge">{{ stepNumbers.gear }}</span>
                        <span>Running Gear</span>
                    </div>
                    <div class="row g-3 pn-section-body">
                        <div class="col-12">
                            <div class="pn-label-row">
                                <label class="pn-label">Tires</label>
                                <i class="fa fa-times pn-clear-btn" *ngIf="partSelection.tireId" (click)="clearTire()"></i>
                            </div>
                            <dx-select-box
                                [(value)]="partSelection.tireId"
                                [items]="partSelection.size?._tireSizes"
                                valueExpr="entityId"
                                displayExpr="name"
                                [disabled]="!partSelection.sizeId || partSelection.size?._tireSizes?.length === 1 || partSelection.brakeType?.disableTireSelection"
                                [width]="'100%'"
                                (onValueChanged)="onTireChanged($event)"
                            ></dx-select-box>
                            <div *ngIf="partSelection.brakeType?.disableTireSelection" class="pn-warning-msg">
                                <i class="fa fa-info-circle"></i> Tire selection disabled for selected brake type.
                            </div>
                        </div>
                    </div>
                </div>
            }

            <!-- Section 3: Suspension & Tires -->
            @if (partSelection?.model?.hasSuspension) {
                <div class="pn-section">
                    <div class="pn-section-header">
                        <span class="pn-step-badge">{{ stepNumbers.gear }}</span>
                        <span>Suspension &amp; Tires</span>
                    </div>
                    <div class="row g-3 pn-section-body">
                        <div class="col-12">
                            <div class="pn-label-row">
                                <label class="pn-label">Suspension</label>
                                <i class="fa fa-times pn-clear-btn" *ngIf="partSelection.suspensionId" (click)="clearSuspension()"></i>
                            </div>
                            <dx-select-box
                                [(value)]="partSelection.suspensionId"
                                [items]="partSelection.size?._suspensions"
                                valueExpr="entityId"
                                displayExpr="name"
                                [disabled]="!partSelection.sizeId || !partSelection.size?._suspensions || partSelection.size._suspensions.length === 1 || partSelection.size?.noSuspension"
                                [width]="'100%'"
                                (onValueChanged)="onSuspensionChanged($event)"
                            ></dx-select-box>
                            <div *ngIf="partSelection.size?.noSuspension" class="pn-warning-msg">
                                <i class="fa fa-info-circle"></i> Suspension selection disabled for selected model size.
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="pn-label-row">
                                <label class="pn-label">Tires</label>
                                <i class="fa fa-times pn-clear-btn" *ngIf="partSelection.tireId" (click)="clearTire()"></i>
                            </div>
                            <dx-select-box
                                [(value)]="partSelection.tireId"
                                [items]="suspensionTires"
                                valueExpr="id"
                                displayExpr="name"
                                [disabled]="!partSelection.suspension || suspensionTires.length === 1 || partSelection.size?.noSuspension"
                                [width]="'100%'"
                                (onValueChanged)="onTireChanged($event)"
                            ></dx-select-box>
                            <div *ngIf="partSelection.size?.noSuspension" class="pn-warning-msg">
                                <i class="fa fa-info-circle"></i> Suspension selection disabled for selected model size.
                            </div>
                        </div>
                    </div>
                </div>
            }

            <!-- Section 4: Body Options -->
            @if (!partSelection.modelTypeId || partSelection?.model?.hasTailOption || partSelection?.model?.hasToonOption || partSelection?.model?.hasPolyCarpetOption) {
                <div class="pn-section">
                    <div class="pn-section-header">
                        <span class="pn-step-badge">{{ stepNumbers.body }}</span>
                        <span>Body Options</span>
                    </div>
                    <div class="row g-3 pn-section-body">
                        @if (!partSelection.modelTypeId) {
                            <div class="col-12 text-muted small fst-italic">Select a model to see options.</div>
                        }
                        @if (partSelection?.model?.hasTailOption) {
                            <div class="col-12">
                                <div class="pn-label-row">
                                    <label class="pn-label">Tail Option</label>
                                    <i class="fa fa-times pn-clear-btn" *ngIf="partSelection.tailOption" (click)="clearTailOption()"></i>
                                </div>
                                <dx-radio-group
                                    [(value)]="partSelection.tailOption"
                                    [items]="['Yes', 'No']"
                                    layout="horizontal"
                                    [disabled]="partSelection.size?.noTailOption"
                                    (onValueChanged)="onTailOptionChanged($event)"
                                ></dx-radio-group>
                                <div *ngIf="partSelection.size?.noTailOption" class="pn-warning-msg">
                                    <i class="fa fa-info-circle"></i> Tail option disabled for selected model size.
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="pn-label-row">
                                    <label class="pn-label">Bunk Bracket Type</label>
                                    <i class="fa fa-times pn-clear-btn" *ngIf="partSelection.bunkBracketOption" (click)="clearBunkBracket()"></i>
                                </div>
                                <dx-radio-group
                                    [(value)]="partSelection.bunkBracketOption"
                                    [items]="['Regular', 'Adjustable']"
                                    layout="horizontal"
                                    [disabled]="partSelection.tailOption === 'No' && partSelection.toonOption === 'Pontoon'"
                                    (onValueChanged)="onBunkBracketOptionChanged($event)"
                                ></dx-radio-group>
                            </div>
                        }
                        @if (partSelection?.model?.hasToonOption) {
                            <div class="col-12">
                                <div class="pn-label-row">
                                    <label class="pn-label">Toon Option</label>
                                    <i class="fa fa-times pn-clear-btn" *ngIf="partSelection.toonOption" (click)="clearToonOption()"></i>
                                </div>
                                <dx-radio-group
                                    [(value)]="partSelection.toonOption"
                                    [items]="['Tritoon', 'Pontoon']"
                                    layout="horizontal"
                                    [disabled]="partSelection.tailOption === 'Yes' || partSelection.size?.noToonOption"
                                    (onValueChanged)="onToonOptionChanged($event)"
                                ></dx-radio-group>
                                <div *ngIf="partSelection.size?.noToonOption" class="pn-warning-msg">
                                    <i class="fa fa-info-circle"></i> Toon option disabled for selected model size.
                                </div>
                            </div>
                        }
                        @if (partSelection?.model?.hasPolyCarpetOption) {
                            <div class="col-12">
                                <div class="pn-label-row">
                                    <label class="pn-label">Bunk Covering</label>
                                    <i class="fa fa-times pn-clear-btn" *ngIf="partSelection.bunkCoveringOption" (click)="clearBunkCovering()"></i>
                                </div>
                                <dx-radio-group
                                    [(value)]="partSelection.bunkCoveringOption"
                                    [items]="['Carpet', 'Poly']"
                                    layout="horizontal"
                                    [disabled]="partSelection.size?.noPolyCarpetOption"
                                    (onValueChanged)="onBunkCoveringOptionChanged($event)"
                                ></dx-radio-group>
                                <div *ngIf="partSelection.size?.noPolyCarpetOption" class="pn-warning-msg">
                                    <i class="fa fa-info-circle"></i> Poly/carpet option disabled for selected model size.
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }

            <!-- Section 5: Hardware & Options -->
            @if (!partSelection.modelTypeId || (partSelection?.model?.hasWinchStand && !partSelection.size?.noWinchStand) || partSelection?.model?.hasTreeOptions || (partSelection?.model?.hasConfigOptions && partSelection.size?._options.length > 0)) {
                <div class="pn-section">
                    <div class="pn-section-header">
                        <span class="pn-step-badge">{{ stepNumbers.hardware }}</span>
                        <span>Hardware &amp; Options</span>
                    </div>
                    <div class="row g-3 pn-section-body">
                        @if (!partSelection.modelTypeId) {
                            <div class="col-12 text-muted small fst-italic">Select a model to see options.</div>
                        }
                        @if (partSelection?.model?.hasWinchStand && !partSelection.size?.noWinchStand) {
                            <div class="col-12">
                                <div class="pn-label-row">
                                    <label class="pn-label">Winch Stand</label>
                                    <i class="fa fa-times pn-clear-btn" *ngIf="partSelection.winchStandId" (click)="clearWinchStand()"></i>
                                </div>
                                <div class="d-flex align-items-center gap-2">
                                    <dx-select-box
                                        [(value)]="partSelection.winchStandId"
                                        [items]="winchStandsDropdown"
                                        valueExpr="entityId"
                                        displayExpr="name"
                                        [disabled]="
                                            !partSelection.sizeId ||
                                            !partSelection.size?._winchStands ||
                                            partSelection.size._winchStands.length === 1 ||
                                            !upgradesEnabled
                                        "
                                        [width]="'100%'"
                                        (onValueChanged)="onWinchStandChanged($event)"
                                    ></dx-select-box>
                                    @if (partSelection?.size?.standardWinchStandId) {
                                        <button
                                            class="btn btn-sm flex-shrink-0"
                                            [class.btn-warning]="upgradesEnabled"
                                            [class.btn-outline-primary]="!upgradesEnabled"
                                            (click)="toggleUpgrades()"
                                        >{{ upgradesEnabled ? 'Cancel' : 'Upgrade' }}</button>
                                    }
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="pn-label-row">
                                    <label class="pn-label">Winch Stand Option</label>
                                    <i class="fa fa-times pn-clear-btn" *ngIf="partSelection.winchStandOptionId" (click)="clearWinchStandOption()"></i>
                                </div>
                                <dx-select-box
                                    [(value)]="partSelection.winchStandOptionId"
                                    [items]="partSelection.winchStand?._options"
                                    valueExpr="optionId"
                                    displayExpr="name"
                                    [disabled]="
                                        partSelection.winchStand?._options.length === 1 ||
                                        (!upgradesEnabled && partSelection?.size?.standardWinchStandOptionId)
                                    "
                                    [width]="'100%'"
                                    (onValueChanged)="onWinchStandOptionChanged($event)"
                                ></dx-select-box>
                            </div>
                        }
                        @if (partSelection?.model?.hasTreeOptions) {
                            <div class="col-12">
                                <div class="pn-label-row">
                                    <label class="pn-label">Place Qty Options</label>
                                    <i class="fa fa-times pn-clear-btn" *ngIf="partSelection.placeQuantityId" (click)="clearPlaceQty()"></i>
                                </div>
                                <dx-select-box
                                    [(value)]="partSelection.placeQuantityId"
                                    [items]="placeQuantityOptions"
                                    valueExpr="id"
                                    displayExpr="name"
                                    [disabled]="!partSelection.sizeId || !placeQuantities || placeQuantities.length === 1 || partSelection.size?.noTreeOptions"
                                    [width]="'100%'"
                                    (onValueChanged)="onPlaceQuantityOptionChanged($event)"
                                ></dx-select-box>
                                <div *ngIf="partSelection.size?.noTreeOptions" class="pn-warning-msg">
                                    <i class="fa fa-info-circle"></i> Tree option disabled for selected model size.
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="pn-label-row">
                                    <label class="pn-label">Cross Arm Options</label>
                                    <i class="fa fa-times pn-clear-btn" *ngIf="partSelection.crossArmId" (click)="clearCrossArm()"></i>
                                </div>
                                <dx-select-box
                                    [(value)]="partSelection.crossArmId"
                                    [items]="crossArms"
                                    valueExpr="id"
                                    displayExpr="name"
                                    [disabled]="!partSelection.sizeId || !crossArms || crossArms.length === 1 || partSelection.size?.noTreeOptions"
                                    [width]="'100%'"
                                    (onValueChanged)="onCrossArmOptionChanged($event)"
                                ></dx-select-box>
                                <div *ngIf="partSelection.size?.noTreeOptions" class="pn-warning-msg">
                                    <i class="fa fa-info-circle"></i> Tree option disabled for selected model size.
                                </div>
                            </div>
                        }
                        @if (partSelection?.model?.hasConfigOptions && partSelection.size?._options.length > 0) {
                            <div class="col-12">
                                <div class="pn-label-row">
                                    <label class="pn-label">Config Options</label>
                                    <i class="fa fa-times pn-clear-btn" *ngIf="partSelection.optionsId" (click)="clearConfigOptions()"></i>
                                </div>
                                <dx-select-box
                                    [(value)]="partSelection.optionsId"
                                    [items]="partSelection.size?._options"
                                    valueExpr="entityId"
                                    displayExpr="name"
                                    [disabled]="!partSelection.sizeId || !partSelection.size?._options || partSelection.size._options.length === 1 || partSelection.size?.noOptions"
                                    [width]="'100%'"
                                    (onValueChanged)="onOptionsChanged($event)"
                                ></dx-select-box>
                                <div *ngIf="partSelection.size?.noOptions" class="pn-warning-msg">
                                    <i class="fa fa-info-circle"></i> Config option disabled for selected model size.
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }

        </div>

        <!-- ── Live Part Number Preview ───────────────────────────── -->
        <div class="pn-preview-panel">
            <div class="pn-preview-card">
                <div class="pn-preview-title">Live Part Number</div>
                <div class="pn-number-display">{{ partNumberString }}</div>
                <div class="pn-price-display" *ngIf="calculatedPrice !== null || true">
                    <span class="pn-price-label">Est. Price</span>
                    <span class="ms-3 pn-price-value">{{ calculatedPrice ?? 0 | currency }}</span>
                </div>
                <div class="pn-segments">
                    <div class="pn-seg" [class.pn-seg--set]="partNumber[0] !== 'XXX'">
                        <span class="pn-seg-key">Model</span>
                        <span class="pn-seg-val">{{ partNumber[0] }}</span>
                    </div>
                    <div class="pn-seg" [class.pn-seg--set]="partNumber[1] !== 'XX'">
                        <span class="pn-seg-key">Size</span>
                        <span class="pn-seg-val">{{ partNumber[1] }}</span>
                    </div>
                    <div class="pn-seg" [class.pn-seg--set]="partNumber[2] !== 'XXX'">
                        <span class="pn-seg-key">Axle</span>
                        <span class="pn-seg-val">{{ partNumber[2] }}</span>
                    </div>
                    <div class="pn-seg" [class.pn-seg--set]="partNumber[3] !== 'X'">
                        <span class="pn-seg-key">Tire</span>
                        <span class="pn-seg-val">{{ partNumber[3] }}</span>
                    </div>
                    <div class="pn-seg" [class.pn-seg--set]="partNumber[4] !== 'X'" *ngIf="showOptionSegments">
                        <span class="pn-seg-key">Option 1</span>
                        <span class="pn-seg-val">{{ partNumber[4] }}</span>
                    </div>
                    <div class="pn-seg" [class.pn-seg--set]="partNumber[5] !== 'X'" *ngIf="showOptionSegments && !partSelection.size?.noWinchStand">
                        <span class="pn-seg-key">Option 2</span>
                        <span class="pn-seg-val">{{ partNumber[5] }}</span>
                    </div>
                </div>
                <div class="pn-preview-actions">
                    <button class="btn btn-sm btn-outline-light" (click)="clear()" [disabled]="processing">
                        <i class="fa fa-refresh me-1"></i>Reset
                    </button>
                    <button class="btn btn-sm btn-primary" (click)="search()" [disabled]="processing || !partSelection.modelTypeId || !partSelection.sizeId">
                        <i class="fa fa-search me-1"></i>Search
                    </button>
                </div>
            </div>
        </div>

    </div>

    <!-- ── Results Grid ───────────────────────────────────────────── -->
    <div class="pn-results">
        <div class="pn-results-header">
            <i class="fa fa-list-ul me-2"></i>Matching Parts
            <span class="pn-results-count">{{ matchingParts?.length ?? 0 }} found</span>
        </div>
        <div class="pn-results-body">
            <div class="d-flex gap-3">
                <div class="pn-half">
                    <dx-data-grid
                        #partsGrid
                        [dataSource]="matchingParts"
                        keyExpr="id"
                        height="360"
                        [columnAutoWidth]="false"
                        (onExporting)="onExporting($event)"
                        (onToolbarPreparing)="onToolbarPreparing($event)"
                        class="lines-grid"
                        [showBorders]="true"
                    >
                        <dxi-column dataField="partNumber" caption="Part Number" width="165"></dxi-column>
                        <dxi-column dataField="description" caption="Description" width="265"></dxi-column>
                        <dxi-column dataField="price" caption="Price" width="120" alignment="right" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
                        <dxi-column width="100"></dxi-column>

                        <dxo-export [enabled]="true"></dxo-export>
                        <dxo-selection mode="single"></dxo-selection>
                        <dxo-state-storing [enabled]="true" [storageKey]="'part-number-grid'"></dxo-state-storing>

                        <div *dxTemplate="let data of 'toolbarButtons'"></div>
                        <div *dxTemplate="let data of 'toolbarText'">
                            <span class="me-3"><strong>Matching Parts: {{ matchingParts?.length ?? 0 }} parts</strong></span>
                        </div>
                    </dx-data-grid>
                </div>

                <div class="pn-selected-panel pn-half">
                    <div class="pn-selected-header">
                        <i class="fa fa-check-circle me-1 text-success"></i>Selected Parts
                        <span class="badge bg-success ms-1">{{ selectedParts.length }}</span>
                    </div>
                    <table class="table table-sm table-hover mb-0">
                        <thead>
                            <tr>
                                <th>Part #</th>
                                <th>Description</th>
                                <!-- <th>IsOption</th> -->
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr [hidden]="selectedParts.length > 0">
                                <td colspan="3" class="text-muted text-center py-3">No items selected</td>
                            </tr>
                            <tr *ngFor="let info of selectedParts">
                                <td [class.option-part-number]="info.isOption" [class.fw-semibold]="!info.isOption">{{ info.partNumber }}</td>
                                <td [class.option-part-number]="info.isOption">{{ info.description }}</td>
                                <!-- <td>{{ info.isOption ? 'Yes' : 'No' }}</td> -->
                                <td class="text-center">
                                    <i class="fa fa-times text-danger pn-remove-btn" (click)="removeFromSelected(info)"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer pn-footer">
    <button
        class="btn btn-success me-auto"
        (click)="add()"
        [disabled]="processing || !matchingParts || matchingParts.length === 0 || partsGrid?.instance.getSelectedRowsData().length === 0"
    >
        <i class="fa fa-plus me-1"></i>Add Selection to Order
    </button>
    <button class="btn btn-secondary" (click)="save()" [disabled]="processing">
        <i class="fa fa-save me-1"></i>Save
    </button>
    <button class="btn btn-outline-danger" (click)="close()">
        <i class="fa fa-times me-1"></i>Cancel
    </button>
</div>
